// ACC-523: typed port of the --fd-* design tokens that lived in index.css :root.
// Values are copied verbatim; this is the single source of truth for ticketing
// styling now that Tailwind is being removed.
const FONT = 'var(--fd-font-family)';
const MONO = '"DM Mono", monospace';

export const ticketingTokens = {
	font: {
		heading1: `700 32px/40px ${FONT}`,
		heading2: `700 28px/36px ${FONT}`,
		heading3: `500 24px/32px ${FONT}`,
		heading4: `500 20px/24px ${FONT}`,
		subheading1: `500 16px/24px ${FONT}`,
		subheading2: `500 14px/20px ${FONT}`,
		label1: `500 14px/20px ${FONT}`,
		body2: `400 14px/20px ${FONT}`,
		body3: `400 12px/16px ${FONT}`,
		overline: `500 11px/16px ${FONT}`,
		mono: `400 12px/16px ${MONO}`,
	},
	color: {
		bgSubtle: '#f5f3f9',
		tintBlue: '#e5f4ff',
		textSecondary: '#6b7280',
		brand50: '#f3e8ff',
		brand100: '#e9d5ff',
		brand500: '#6e0feb',
		dark100: '#e2e8f0',
		dark500: '#64748b',
		dark700: '#334155',
		dark900: '#0f172a',
		interactivePrimary: '#6e0feb',
		statusOpenBg: '#dbeafe',
		statusOpenText: '#1e40af',
		statusInProgressBg: '#fef9c3',
		statusInProgressText: '#854d0e',
		statusWaitingBg: '#ffedd5',
		statusWaitingText: '#9a3412',
		statusResolvedBg: '#dcfce7',
		statusResolvedText: '#166534',
		statusClosedBg: '#f1f5f9',
		statusClosedText: '#475569',
		criticalBg: '#fee2e2',
		criticalText: '#991b1b',
		highBg: '#ffedd5',
		highText: '#9a3412',
		mediumBg: '#fef9c3',
		mediumText: '#854d0e',
		lowBg: '#f1f5f9',
		lowText: '#475569',
		dangerBg: '#fef2f2',
		dangerText: '#dc2626',
		dangerBorder: '#fecaca',
		neutralBg: '#f1f5f9',
		neutralText: '#94a3b8',
		warningBg: '#fff7ed',
		warningText: '#ea580c',
		warningBorder: '#fed7aa',
		onTrackText: '#0d9488',
		accentChartreuse: '#ebff73',
	},
	radius: {
		xs: '2px',
		m: '8px',
		full: '9999px',
	},
	shadow: {
		// Medium-elevation shadow used for expanded dropdowns and popovers (Sky-theme "Shadow 2").
		shadow2: '0 4px 16px rgba(0, 0, 0, 0.12)',
		// High-elevation shadow used for modals (Sky-theme "Shadow 3"), always paired
		// with a 1px dark100 hairline border.
		shadow3: '0 12px 24px -4px rgba(35,35,52,.12), 0 4px 8px -2px rgba(35,35,52,.06)',
	},
} as const;

export type TicketingTokens = typeof ticketingTokens;
